<!--<search class="no-print"></search>-->
<style>
  .table {
    margin-bottom: 0;
  }

  .panel {
    margin-bottom: 15px;
  }
</style>
<app-search></app-search>
<div class="row" style="margin:10px 0px;">
  <div class="col-md-12">
    <div class="panel panel-default" style="border: none;">
      <h3>Permit Dashboard</h3>
      <div class="dashboarddatepicker">
        <label style="padding: 4px">Start Date
          <input type="date" class="form-control" [(ngModel)]="startDate"/>
        </label>
        <label style="padding: 4px">End Date
          <input type="date" class="form-control" [(ngModel)]="endDate"/>
        </label>
        <button class="btn btn-primary" style="margin-top: 9px" (click)="updateQueryParams()">
          Apply Date Range
        </button>
        <label class="dashboardlegend" (click)="dateIsCollapsed = !dateIsCollapsed">Date Range Legend
          <i *ngIf="dateIsCollapsed && !loadingLegend"
             class="pull-left fa fa-chevron-down"></i>
          <i *ngIf="!dateIsCollapsed && !loadingLegend" class="pull-left fa fa-chevron-up"></i>
          <li *ngFor="let range of dateRanges" style="list-style-type: none;" [ngbCollapse]="dateIsCollapsed">
            {{ getQuarterLabel(range.start) + ': ' + range.start.format('LL')}} -
            {{range.end.format('LL')}} </li>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="panel panel-default printing">
          <div class="panel-heading">
            Average Processing Time for Completed Reviews by Group and Quarter (Days)
          </div>
          <div class="panel-body">
            <div><i *ngIf="loadingCompleteReviews" class="fa fa-spinner fa-pulse"></i></div>
            <div [style.display]="loadingCompleteReviews ? 'none' : ''" id="review_time_group"></div>
          </div>
        </div>
        <div class="panel panel-default printing">
          <div class="panel-heading">
            Average Processing Time for Completed Reviews by Sub-Type and Status (Days)
          </div>
          <div class="panel-body">
            <div><i *ngIf="loadingCompleteReviews" class="fa fa-spinner fa-pulse"></i></div>
            <div [style.display]="loadingCompleteReviews ? 'none' : ''" id="review_time_type"></div>
          </div>
        </div>
        <div class="panel panel-default printing">
          <div class="panel-heading">
            Completed Reviews by Group
          </div>
          <div class="panel-body">
            <div><i *ngIf="loadingCompleteReviews" class="fa fa-spinner fa-pulse"></i></div>
            <div [style.display]="loadingCompleteReviews ? 'none' : ''" id="quarter_count_group"></div>
          </div>
        </div>

        <!--        <div class="panel panel-default printing">-->
        <!--          <div class="panel-heading">-->
        <!--            Current Reviewers-->
        <!--          </div>-->
        <!--          <div class="panel-body">-->
        <!--            <div><i *ngIf="loadingReviews" class="fa fa-spinner fa-pulse"></i></div>-->
        <!--            <div [style.display]="loadingReviews ? 'none' : ''" id="current_reviewers_table"></div>-->
        <!--          </div>-->
        <!--        </div>-->


      </div>
      <div class="col-md-6">
        <div class="panel panel-default printing">
          <div class="panel-heading">
            Completed/On-Hold Permits
          </div>
          <div class="panel-body">
            <div><i *ngIf="loadingCompleteReviews" class="fa fa-spinner fa-pulse"></i></div>
            <div [style.display]="loadingCompleteReviews ? 'none' : ''" id="permit_status"></div>
          </div>
        </div>
        <div class="panel panel-default printing">
          <div class="panel-heading">
            Received Permits
          </div>
          <div class="panel-body">
            <div><i *ngIf="loadingPermitsBySubmissionDate" class="fa fa-spinner fa-pulse"></i></div>
            <div [style.display]="loadingPermitsBySubmissionDate ? 'none' : ''" id="submitted_permits"></div>
          </div>
        </div>
        <div class="panel panel-default printing">
          <div class="panel-heading">
            Outstanding Reviews by Group
          </div>
          <div class="panel-body">
            <div><i *ngIf="loadingOngoingReviews" class="fa fa-spinner fa-pulse"></i></div>
            <div [style.display]="loadingOngoingReviews ? 'none' : ''" id="outstanding_group_reviews_table"></div>
          </div>
        </div>
        <div class="panel panel-default printing">
          <div class="panel-heading">
            Outstanding Reviews by Reviewer
          </div>
          <div class="panel-body">
            <div><i *ngIf="loadingOngoingReviews" class="fa fa-spinner fa-pulse"></i></div>
            <div [style.display]="loadingOngoingReviews ? 'none' : ''" id="outstanding_individual_reviews_table"></div>
          </div>
        </div>

      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-default printing">
          <div class="panel-heading">
            Completed Reviews Exploration
          </div>
          <div class="panel-body">
            <div><i *ngIf="loadingCompleteReviews" class="fa fa-spinner fa-pulse"></i></div>
            <div [style.display]="loadingCompleteReviews ? 'none' : ''" id="completed_exploration"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-default printing">
          <div class="panel-heading">
            Ongoing Reviews Exploration
          </div>
          <div class="panel-body">
            <div><i *ngIf="loadingOngoingReviews" class="fa fa-spinner fa-pulse"></i></div>
            <div [style.display]="loadingOngoingReviews ? 'none' : ''" id="ongoing_exploration"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-default printing">
          <div class="panel-heading">
            One Stop Permit Data Exploration
          </div>
          <div class="panel-body">
            <div><i *ngIf="loadingOngoingReviews" class="fa fa-spinner fa-pulse"></i></div>
            <div [style.display]="loadingOngoingReviews ? 'none' : ''" id="onestop_permits"></div>
          </div>
        </div>
      </div>
    </div>
  </div>


</div>

<div class="print-only">

</div>
